const getDecimalPlaces = (num) => {
    const str = num.toString();
    if (str.includes('e')) {
        // Convert to fixed-point notation
        const fixed = num.toFixed(20); // choose a high precision
        return fixed.replace(/0+$/, '').split('.')[1]?.length || 0;
    }
    return str.includes('.') ? str.split('.')[1].length : 0;
};
function spinUp(input) {
    if (input) {
        let val = parseFloat(input.value);
        let newValue = val;
        let max = 0;
        let min = 0;
        let step = 1;
        let isDisabled = false;

        if (input.getAttribute('max')) {
            max = parseFloat(input.getAttribute('max'));
        }

        if (input.getAttribute('min')) {
            min = parseFloat(input.getAttribute('min'));
        }

        if (input.getAttribute('step')) {
            step = parseFloat(input.getAttribute('step'));
        }

        if (input.disabled) {
            isDisabled = true;
        }

        if (input.readonly) {
            isDisabled = true;
        }

        if (!isDisabled) {
            if (max !== undefined && max > 0) {
                if (max >= val + step ) {
                    newValue = val + step;
                }
            } else {
                newValue = val + step;
            }
        }

        if(newValue !== 0 && newValue < min) {
            newValue = min;
        }
        newValue=newValue.toFixed(getDecimalPlaces(step));

        input.value = newValue;
    }
}

function spinDown(input) {
    if (input) {
        let val = parseFloat(input.value);
        let newValue = val;
        let min = 0;
        let step = 1;
        let isDisabled = false;

        if (input.getAttribute('min')) {
            min = parseFloat(input.getAttribute('min'));
        }

        if (input.getAttribute('step')) {
            step = parseFloat(input.getAttribute('step'));
        }

        if (input.disabled) {
            isDisabled = true;
        }

        if (input.readonly) {
            isDisabled = true;
        }

        if (!isDisabled) {
            if (((val - step) % step) > 0) {
                if (min <= val - step) {
                    newValue = val - step;
                }
            } else {
                if (min <= val - step) {
                    newValue = val - step;
                }
            }
        }
        newValue=newValue.toFixed(getDecimalPlaces(step));

        input.value = newValue;
    }
}

export function getAllQuantityInputs(wrapper = document){
    return wrapper.querySelectorAll('.quantity input[type="number"]');
}

export function initQuantitySpinners(done = function () {
}) {
    document.addEventListener("click", function (e) {
        let target = e.target;
        let quantity = target.closest('.quantity');
        if (quantity) {
            let input = target.closest('.quantity').querySelector('input[type="number"]');
            if (input) {
                if (target.closest('.js-spinnerUp')) {
                    spinUp(input);
                    done(input);
                }
                if (target.closest('.js-spinnerDown')) {
                    spinDown(input);
                    done(input);
                }
            }
        }
    });
}